import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { NoResultFoundComponent } from '../../../../../../shared/components/no-result-found/no-result-found.component';

@Component({
  selector: 'app-patient-info',
  standalone: true,
  imports: [DialogModule, ButtonModule, TranslateModule, TableModule, NoResultFoundComponent],
  templateUrl: './patient-info.component.html',
  styleUrl: './patient-info.component.scss'
})
export class PatientInfoComponent {
  @Input() visible: boolean = false;
  @Input() patientCodes: string[] = [];
  @Output() onClose = new EventEmitter<void>();

  closeDialog() {
    this.onClose.emit();
  }
}
